import { memo } from 'react';

import { Button } from '@air/primitive-button';

type RegenerateShareLinkButtonsProps = {
  onClose: () => void;
  onRegenerate: () => void;
  isLoading: boolean;
};

export const RegenerateShareLinkButtons = memo(
  ({ onRegenerate, onClose, isLoading }: RegenerateShareLinkButtonsProps) => {
    return (
      <div className="flex justify-end gap-3">
        <Button
          appearance="ghost"
          color="grey"
          size="large"
          onClick={onClose}
          disabled={isLoading}
          data-testid="REGENERATE_SHARE_LINK_CANCEL_BUTTON"
        >
          Cancel
        </Button>
        <Button
          appearance="filled"
          isLoading={isLoading}
          color="blue"
          size="large"
          onClick={onRegenerate}
          data-testid="REGENERATE_SHARE_LINK_CONFIRM_BUTTON"
        >
          Confirm
        </Button>
      </div>
    );
  },
);

RegenerateShareLinkButtons.displayName = 'RegenerateShareLinkButtons';
